<script lang="ts">
	import { dev } from '$app/environment';
	import type { presenterHubUserContext } from '$lib/api/rpc';
	import { atLeastModerator } from '$lib/utils/roles';
	import { onMount } from 'svelte';
	export let user_context: presenterHubUserContext;
	export let email: string;

	//Only render pendo if the user is atLeastModerator
	const shouldRenderPendo = !dev && atLeastModerator(user_context);
	onMount(() => {
		if (!shouldRenderPendo) {
			return;
		}
		let script = document.getElementById('pendoScript');
		// Hack to get the script to run after mount
		if (script) {
			script.innerText = `(function (apiKey) { (function (p, e, n, d, o) { var v, w, x, y, z; o = p[d] = p[d] || {}; o._q = o._q || []; v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track']; for (w = 0, x = v.length; w < x; ++w) (function (m) { o[m] = o[m] || function () { o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0))); }; })(v[w]); y = e.createElement(n); y.async = !0; y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js'; z = e.getElementsByTagName(n)[0]; z.parentNode.insertBefore(y, z); })(window, document, 'script', 'pendo'); })('04a8bde1-5d70-4760-5555-4f0f0f03f4f4');`;
		}
		// @ts-ignore
		// eslint-disable-next-line no-undef
		pendo.initialize({ visitor: { id: email } });
	});
</script>

<svelte:head>
	<script id="pendoScript"></script>
</svelte:head>
